import { mq, screen } from "lib/media-query";
import styled, { css } from "styled-components";

export const StyledIcon = styled.div`
    display: none;
    ${({ theme }) => mq.to(screen.LG)`
    display: flex;
    fill: ${theme.colors.white};
    height: 1.3em;
    width: 1.3em;
    margin-right: 6px;
    `}
`;

export const HamburgerMenuContainer = styled.button`
    visibility: hidden;

    ${mq.to(screen.LG) &&
    css`
        cursor: pointer;
        position: absolute;
        right: 0;
        border: none;
        outline: none;
        padding: 0.25rem 0.75rem;
        background-color: transparent;
        visibility: visible;
    `}
`;

export const HamburgerMenu = styled.span<{ change: boolean }>`
    ${({ change, theme }) => mq.to(screen.LG)`
    background-color: ${!change ? theme.colors.black : "transparent"};
    display: block;
    height: 3px;
    position: relative;
    width: 20px;
    &:before {
        background-color: ${theme.colors.black};
        content: "";
        height: 3px;
        position: absolute;
        right: 0;
        top: ${!change ? "-6px" : "0"};
        transform: ${!change ? "rotate()" : "rotate(-45deg)"};
        transition: all 0.3s linear;
        width: 20px;
    }
    &:after {
        background-color: ${theme.colors.black};
        bottom: ${!change ? "-6px" : "0"};
        content: "";
        height: 3px;
        position: absolute;
        right: 0;
        transform: ${!change ? "rotate()" : "rotate(45deg)"};
        transition: all 0.3s linear;
        width: 20px;
    }
    `}
`;
